// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/cssWithMappingToString.js");
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".video-iframe{width:100%;position:relative;height:60vh}", "",{"version":3,"sources":["webpack://./modals/YoutubeVideoModal.vue"],"names":[],"mappings":"AACC,cACG,UAAW,CACX,iBAAkB,CAClB,WACJ","sourcesContent":["\n .video-iframe {\n    width: 100%;\n    position: relative;\n    height: 60vh;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
